import { Box, SvgIcon } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  outerBox: {
    margin: "24px 0",
    background: "#f7f7f7",
    borderRadius: "3px",
  },
  content: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fdfdfd",
    fontSize: "500px",
  },
});

export default function EmptyPage() {
  const classes = useStyles();

  return (
    <Box className={classes.outerBox} height="calc(100vh - 112px)">
      <Box className={classes.content}>
        <SvgIcon fontSize="inherit">
          <Logo color="#f0f0f0" />
        </SvgIcon>
      </Box>
    </Box>
  );
}
